import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { getInitials } from '../utils/format';
import Icon from '../components/Icon';
import './Messages.css';

function Messages() {
  const { user } = useAuth();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadConversations();
  }, []);

  const loadConversations = async () => {
    try {
      const data = await api.getConversations();
      setConversations(data);
    } catch (err) {
      console.error('Failed to load conversations:', err);
    } finally {
      setLoading(false);
    }
  };

  const getOtherParticipant = (conversation) => {
    return conversation.participants?.find(p => p.id !== user?.id) || {};
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;

    // Less than 24 hours
    if (diff < 86400000) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    // Less than 7 days
    if (diff < 604800000) {
      return date.toLocaleDateString([], { weekday: 'short' });
    }

    // More than 7 days
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="messages-page container">
      <div className="messages-header">
        <h1>Messages</h1>
        <p>Chat with your connections</p>
      </div>

      {conversations.length > 0 ? (
        <div className="conversations-list">
          {conversations.map(conversation => {
            const other = getOtherParticipant(conversation);
            const isUnread = conversation.unread_count > 0;

            return (
              <Link
                key={conversation.id}
                to={`/messages/${conversation.id}`}
                className={`conversation-item card ${isUnread ? 'unread' : ''}`}
              >
                <div className="avatar">
                  {other.photo_url ? (
                    <img src={other.photo_url} alt={other.name} />
                  ) : (
                    getInitials(other.name)
                  )}
                </div>
                <div className="conversation-content">
                  <div className="conversation-header">
                    <h3 className="conversation-name">{other.name || 'Unknown'}</h3>
                    <span className="conversation-time">
                      {formatTime(conversation.last_message_at)}
                    </span>
                  </div>
                  <p className="conversation-preview">
                    {conversation.last_message_sender_id === user?.id && (
                      <span className="you-prefix">You: </span>
                    )}
                    {conversation.last_message_content || 'No messages yet'}
                  </p>
                </div>
                {isUnread && (
                  <span className="unread-badge">{conversation.unread_count}</span>
                )}
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="empty-state card">
          <div className="empty-state-icon"><Icon name="chat" size={24} /></div>
          <p className="empty-state-title">No messages yet</p>
          <p className="empty-state-text">
            Connect with golfers and start a conversation to plan your next round.
          </p>
          <Link to="/connections" className="btn btn-primary" style={{ marginTop: 16 }}>
            View Connections
          </Link>
        </div>
      )}
    </div>
  );
}

export default Messages;
